import { render, staticRenderFns } from "./ongoing-call-area.vue?vue&type=template&id=b55a5866"
import script from "./ongoing-call-area.vue?vue&type=script&lang=js"
export * from "./ongoing-call-area.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports